var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCodeDeleteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4C1.75 2.20508 3.20507 0.75 5 0.75H18C19.7949 0.75 21.25 2.20507 21.25 4V21C21.25 22.7949 19.7949 24.25 18 24.25H5C3.20507 24.25 1.75 22.7949 1.75 21V4Z",
    stroke: "#0D4CF6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H16",
    stroke: "#0D4CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H13",
    stroke: "#0D4CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4892 17.2277C12.7262 16.9261 13.0885 16.75 13.4721 16.75H27C27.6904 16.75 28.25 17.3096 28.25 18V28C28.25 28.6904 27.6904 29.25 27 29.25H13.4721C13.0885 29.25 12.7262 29.0739 12.4892 28.7723L8.5606 23.7723C8.20446 23.319 8.20446 22.681 8.5606 22.2277L12.4892 17.2277Z",
    fill: "black",
    stroke: "#0D4CF6",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4219 19.8086L17.8092 25.4213",
    stroke: "#0D4CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8047 19.8086L23.4173 25.4213",
    stroke: "#0D4CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCodeDeleteOn);
export default __webpack_public_path__ + "static/media/ic_code_delete_on.65b61529d102c76d2cb9c5d4b49faf9d.svg";
export { ForwardRef as ReactComponent };